import { render } from "./ViewVideo.vue?vue&type=template&id=31f12dfc&scoped=true"
import script from "./ViewVideo.vue?vue&type=script&lang=js"
export * from "./ViewVideo.vue?vue&type=script&lang=js"

import "./ViewVideo.vue?vue&type=style&index=0&id=31f12dfc&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f12dfc"]])

export default __exports__